import { render, staticRenderFns } from "./MaisPetFriends.vue?vue&type=template&id=10acd393"
import script from "./MaisPetFriends.vue?vue&type=script&lang=js"
export * from "./MaisPetFriends.vue?vue&type=script&lang=js"
import style0 from "./MaisPetFriends.vue?vue&type=style&index=0&id=10acd393&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports